import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import InventoryIcon from "@mui/icons-material/Inventory";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import StoreMallDirectoryRoundedIcon from "@mui/icons-material/StoreMallDirectoryRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import logo from "../Assets/Iridis.png";
import "../../styles/sidebar.css";

const Sidebar = ({ setActiveTab, activeTab }) => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleClick = (tab) => {
    setActiveTab(tab);
    if (isMobile) {
      setIsOpen(false);
    }
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const activeItemStyle = {
    backgroundColor: "#5359c9",
    color: "white",
    width: "100%",
    padding: "14px 16px",
    borderRadius: "8px",
  };

  const inactiveItemStyle = {
    width: "100%",
    padding: "14px 16px",
    borderRadius: "8px",
  };

  return (
    <>
      {/* Hamburger Menu Button for mobile */}
      {isMobile && (
        <IconButton
          onClick={toggleSidebar}
          sx={{
            position: "fixed",
            top: 16,
            left: 16,
            zIndex: 1300,
            backgroundColor: "white",
            boxShadow: 2,
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          {isOpen ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      )}

      {/* Overlay for mobile */}
      {isMobile && isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1200,
          }}
        />
      )}

      {/* Sidebar */}
      <div
        className={`sidebar ${isMobile ? "mobile-sidebar" : ""}`}
        style={{
          transform: isMobile
            ? isOpen
              ? "translateX(0)"
              : "translateX(-100%)"
            : "translateX(0)",
          transition: "transform 0.3s ease-in-out",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: isMobile ? 1250 : 1000,
          height: "100vh",
          width: isMobile ? "280px" : "280px",
          overflowY: "auto",
        }}
      >
        <div className="sidelogo">
          <img src={logo} alt="" className="logoimg" />
          <span className="system-title">Asset Management System</span>
        </div>

        <List className="tabs" sx={{ padding: 0 }}>
          <ListItem
            button
            onClick={() => handleClick("Dashboard")}
            className={`tab-item ${activeTab === "Dashboard" ? "active" : ""}`}
            sx={activeTab === "Dashboard" ? activeItemStyle : inactiveItemStyle}
          >
            <ListItemIcon
              className="tab-icon"
              sx={{ color: "inherit", minWidth: "40px" }}
            >
              <HomeRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" sx={{ color: "inherit" }} />
          </ListItem>

          <ListItem
            button
            onClick={() => handleClick("Asset Register")}
            className={`tab-item ${
              activeTab === "Asset Register" ? "active" : ""
            }`}
            sx={
              activeTab === "Asset Register"
                ? activeItemStyle
                : inactiveItemStyle
            }
          >
            <ListItemIcon
              className="tab-icon"
              sx={{ color: "inherit", minWidth: "40px" }}
            >
              <InventoryIcon />
            </ListItemIcon>
            <ListItemText primary="Asset Register" sx={{ color: "inherit" }} />
          </ListItem>

          <ListItem
            button
            onClick={() => handleClick("Inventory")}
            className={`tab-item ${activeTab === "Inventory" ? "active" : ""}`}
            sx={activeTab === "Inventory" ? activeItemStyle : inactiveItemStyle}
          >
            <ListItemIcon
              className="tab-icon"
              sx={{ color: "inherit", minWidth: "40px" }}
            >
              <StoreMallDirectoryRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Inventory" sx={{ color: "inherit" }} />
          </ListItem>

          <ListItem
            button
            onClick={() => handleClick("Asset Tracking")}
            className={`tab-item ${
              activeTab === "Asset Tracking" ? "active" : ""
            }`}
            sx={
              activeTab === "Asset Tracking"
                ? activeItemStyle
                : inactiveItemStyle
            }
          >
            <ListItemIcon
              className="tab-icon"
              sx={{ color: "inherit", minWidth: "40px" }}
            >
              <AssignmentTurnedInRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Asset Tracking" sx={{ color: "inherit" }} />
          </ListItem>

          <ListItem
            button
            onClick={() => handleClick("Users")}
            className={`tab-item ${activeTab === "Users" ? "active" : ""}`}
            sx={activeTab === "Users" ? activeItemStyle : inactiveItemStyle}
          >
            <ListItemIcon
              className="tab-icon"
              sx={{ color: "inherit", minWidth: "40px" }}
            >
              <LaptopMacIcon />
            </ListItemIcon>
            <ListItemText primary="Users" sx={{ color: "inherit" }} />
          </ListItem>

          <ListItem
            button
            onClick={() => handleClick("Staff")}
            className={`tab-item ${activeTab === "Staff" ? "active" : ""}`}
            sx={activeTab === "Staff" ? activeItemStyle : inactiveItemStyle}
          >
            <ListItemIcon
              className="tab-icon"
              sx={{ color: "inherit", minWidth: "40px" }}
            >
              <PeopleAltRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Staff" sx={{ color: "inherit" }} />
          </ListItem>

          <ListItem
            button
            onClick={() => handleClick("Logout")}
            className="logout"
            sx={{
              color: "#dc3545",
              marginTop: "20px",
              width: "100%",
              padding: "14px 16px",
              "&:hover": {
                backgroundColor: "rgba(220, 53, 69, 0.08)",
                color: "#c82333",
              },
            }}
          >
            <ListItemIcon
              className="tab-icon"
              sx={{ color: "inherit", minWidth: "40px" }}
            >
              <LogoutRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" sx={{ color: "inherit" }} />
          </ListItem>
        </List>
      </div>
    </>
  );
};

export default Sidebar;
